import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateAccountLedgerMutationVariables = Types.Exact<{
  input: Types.UpdateAccountLedgerInput;
}>;


export type UpdateAccountLedgerMutation = { __typename?: 'Mutation', updateAccountLedger: { __typename?: 'AccountLedger', id: string, comment?: string | null, hidden_at?: string | null, hidden_by?: string | null } };


export const UpdateAccountLedgerDocument = gql`
    mutation UpdateAccountLedger($input: UpdateAccountLedgerInput!) {
  updateAccountLedger(input: $input) {
    id
    comment
    hidden_at
    hidden_by
  }
}
    `;
export type UpdateAccountLedgerMutationFn = Apollo.MutationFunction<UpdateAccountLedgerMutation, UpdateAccountLedgerMutationVariables>;

/**
 * __useUpdateAccountLedgerMutation__
 *
 * To run a mutation, you first call `useUpdateAccountLedgerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountLedgerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountLedgerMutation, { data, loading, error }] = useUpdateAccountLedgerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountLedgerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountLedgerMutation, UpdateAccountLedgerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountLedgerMutation, UpdateAccountLedgerMutationVariables>(UpdateAccountLedgerDocument, options);
      }
export type UpdateAccountLedgerMutationHookResult = ReturnType<typeof useUpdateAccountLedgerMutation>;
export type UpdateAccountLedgerMutationResult = Apollo.MutationResult<UpdateAccountLedgerMutation>;
export type UpdateAccountLedgerMutationOptions = Apollo.BaseMutationOptions<UpdateAccountLedgerMutation, UpdateAccountLedgerMutationVariables>;